<template>
  <div class="h-100">
    <v-toolbar v-if="$route.meta.toolbar" fixed color="transparent" dark flat scroll-off-screen>
      <v-spacer></v-spacer>
      <v-toolbar-items class="hidden-sm-and-down">
        <v-btn flat>Home</v-btn>
          <v-menu bottom left>
            <v-btn
              slot="activator"
              flat
            >
              Fresh Start <v-icon right>keyboard_arrow_down</v-icon>
            </v-btn>
            <v-list>
              <v-list-tile>
                <v-list-tile-title>About Fresh Start</v-list-tile-title>
              </v-list-tile>
              <v-list-tile>
                <v-list-tile-title>Login</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        <v-btn flat>Link Three</v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-content>
      <v-container fluid fill-height>
        <v-content>
        <slot />
        </v-content>
      </v-container>
    </v-content>
  </div>
</template>

<script>
export default {
  name: 'app',
  data () {
    return {
    }
  }
}
</script>

<style scoped>
.container.fluid {
  padding: 0px!important;
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/guest.vue